import { MAP_TYPES } from "@deck.gl/carto";
import { CONNECTION } from "../config.js";
const VISITORS_ORIGINS_SOURCE_ID = "visitorsOriginsSource";

const source = {
  id: VISITORS_ORIGINS_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: CONNECTION.connection,
  data: `SELECT * FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.origin_destination} WHERE geo_id_destination = '{geoid}'`,
};

export default source;
